module.exports = __webpack_public_path__ + "img/science-1.45bf2e55.jpg";